export default "__VITE_ASSET__BiV4F1XU__"